import { BrowserGlobalProperties } from "@veridapt/browser-helpers";
import { CoreGlobalProperties, useGlobalProperties } from "@veridapt/core";
import { csrfToken } from "@rails/ujs";

useGlobalProperties([
  [BrowserGlobalProperties.CSRFToken, csrfToken as () => string],
  [CoreGlobalProperties.I18nConfig, () => JSON.stringify(globalThis.I18n)],
]);
